// extracted by mini-css-extract-plugin
export default {"sidebar-footer":"SidebarFooter_sidebar-footer__kaJHY"};